import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Header, Footer } from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import ManifestoPage from "@/pages/ManifestoPage";
import TokenomicsPage from "@/pages/TokenomicsPage";
import MemePage from "@/pages/MemePage";
import VaultPage from "@/pages/VaultPage";
import NewsPage from "@/pages/NewsPage";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/"            element={<HomePage />} />
            <Route path="/manifesto"   element={<ManifestoPage />} />
            <Route path="/tokenomics"  element={<TokenomicsPage />} />
            <Route path="/meme"        element={<MemePage />} />
            <Route path="/vault"       element={<VaultPage />} />
            <Route path="/news"        element={<NewsPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
